import { WidgetRegistry } from "@Widgets/types";
import { ServiceOfferModalWithButton } from "../Components/ServiceOfferModalWithButton";

const serviceRequestWidgetRegistry: Pick<
  WidgetRegistry,
  "ServiceRequest.See.Offer.Detail"
> = {
  "ServiceRequest.See.Offer.Detail": {
    Component: ServiceOfferModalWithButton,
  },
};

export default serviceRequestWidgetRegistry;
